import {FormElement, FormElementParent} from '@/scripts/types/form-elements.ts';

export const traverseSchema = (
	parent: FormElementParent,
	visitor: (element: FormElement, parent: FormElementParent) => boolean | void
): boolean | void => {
	for (const element of parent.schema.elements) {
		const result = visitor(element, parent);
		if (result) return true;

		if ('schema' in element) {
			const nestedResult = traverseSchema(element, visitor);
			if (nestedResult) return true;
		}
	}
	return false;
};

export const traverseSchemaAsync = async (
	parent: FormElementParent,
	visitor: (
		element: FormElement,
		parent: FormElementParent
	) => Promise<boolean | void>
): Promise<boolean | void> => {
	for (const element of parent.schema.elements) {
		const result = await visitor(element, parent);
		if (result === true) return true;

		if ('schema' in element) {
			const nestedResult = await traverseSchemaAsync(element, visitor);
			if (nestedResult === true) return true;
		}
	}
	return false;
};
